<template>
  <div class="project-list padding_20">
    <div class="common-search__header">
      <div class="common-search__title">
        项目列表
      </div>
      <el-button type="primary"
                 plain
                 icon="el-icon-circle-plus"
                 @click="$router.push({ path: '/add-project' })">
        新建项目
      </el-button>
    </div>
    <Search ref="placeSearch"
            :search-array="searchArray"
            @getData="getData" />
    <commonTable :table-data="commonTableData"
                 :common-table-array="commonTableArray"
                 :is-show-operate="Boolean('true')"
                 :is-show-editor="Boolean('true')"
                 :is-show-delete="Boolean('true')"
                 :total="total"
                 :current-page="page"
                 :page-size="size"
                 @handlePage="handlePage"
                 @deleteData="deleteData"
                 @editorData="editorData"
                 @handleItem="handleItem" />
  </div>
</template>

<script>
import Search from '@/components/common/Search.vue';
import commonTable from '@/components/common/commonTable.vue';
import { getAllPlaces } from '@/api/place';
import { getProjectAll, deleteProject } from '@/api/project';

export default {
  components: { Search, commonTable },
  data() {
    return {
      searchArray: [
        {
          label: '项目名称',
          props: 'name',
          type: 'input',
        },
        {
          label: '场',
          props: 'place_id',
          type: 'select',
          list: [],
        },
        {
          label: '类型',
          props: 'solution',
          type: 'select',
          list: [
            {
              id: 'Mall',
              name: 'Mall',
            },
            {
              id: 'Store',
              name: 'Store',
            },
            {
              id: 'ParkingLot',
              name: 'ParkingLot',
            },
            {
              id: 'Navigation',
              name: 'Navigation',
            },
          ],
        },
      ],
      commonTableData: [],
      commonTableArray: [
        {
          label: '项目名称',
          props: 'name',
          handle: true,
        },
        {
          label: '类型',
          props: 'solution',
        },
        {
          label: '产品类型',
          props: 'product',
        },
        {
          label: '场',
          props: 'place_name',
        },
        {
          label: '创建日期',
          props: 'created_at',
        },
        {
          label: '流程',
          props: 'flow_id',
        },
      ],
      total: 0,
      page: 1,
      size: 20,
    };
  },
  created() {
    this.getAllPlaces();
    this.getProjectAll();
  },
  methods: {
    getData(data) {
      this.getProjectAll(data);
    },
    async getAllPlaces() {
      const { data } = await getAllPlaces({});
      this.searchArray[1].list = data;
    },
    async getProjectAll(data) {
      const { page, size } = this;
      await getProjectAll({ page, size, ...data }).then((res) => {
        this.commonTableData = res.data.list;
        this.total = res.data.total;
      });
    },
    handlePage(page) {
      this.page = page;
      this.getProjectAll();
    },
    deleteData(item) {
      deleteProject(item.id).then(() => {
        this.getProjectAll();
        this.$message({
          message: '删除成功',
          type: 'success',
        });
      });
    },
    editorData(item) {
      this.$router.push({ path: '/add-project', query: { id: item.id } });
    },
    handleItem(item) {
      this.$router.push({ path: '/workbench/index', query: { place_id: item.place_id, project_id: item.id } });
    },
  },
};
</script>
<style lang="less" scoped>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.my-label-tasks__header {
  margin-bottom: 10px;
}
.list {
  margin: 25px 0;
  box-sizing: border-box;
  padding: 20px;
  overflow: hidden;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.place_detail {
  color: #2c2c2e;
}
</style>
